import { render } from "./octVegas.vue?vue&type=template&id=fabde294"
import script from "./octVegas.vue?vue&type=script&lang=js"
export * from "./octVegas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__